<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="row mt-3 mb-3">
  <div class="col-4">
    <button #btnAdicionarExecutora (click)="adicionarExecutora()" data-toggle="modal" data-target="#dialogExecutora"
      class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar unidade executora
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="listaExecutoras && listaExecutoras.length > 0">
  <thead>
    <tr>
      <th scope="col">Código</th>
      <th scope="col">Nome</th>
      <th scope="col">tribunal N˚</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaExecutoras; let idx = index">
      <td style="width: 200px">{{item.codigo}}</td>
      <td style="width: 60%">{{item.nome}}</td>
      <td style="width: 200px">{{item.tribunal}}</td>
      <td class="text-right" style="min-width: 150px;">
        <button #btnEditarExecutora (click)="editarExecutora(item)" data-toggle="modal" data-target="#dialogExecutora"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button (click)="removerExecutora(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>

<div #modal class="modal fade" id="dialogExecutora" tabindex="-1" role="dialog" aria-labelledby="executora"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <img src="assets/img/real-estate.png" alt="executora" height="32px" width="32px"
          class="float-left mr-2">
        <h5 class="modal-title pl-1" id="title" *ngIf="codigou">
          <span>Unidade executora</span>
          <p
            style="font-weight: bold; font-size: 0.85rem; line-height: 3px;">
            Informe os dados da unidade executora - UA: {{codigou}}
        </p>
        </h5>
        <br />

        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #f="ngForm" id="form_register" novalidate="" autocomplete="off">
        <input [(ngModel)]="entity.id" type="text" ngModel name="id" id="id" style="display: none">
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group col-2">
              <label for="codigo" class="col-form-label">Código<span class="text-danger">*</span></label>
              <input #codigoe autofocus [(ngModel)]="entity.codigo" type="text" ngModel name="codigo"
                class="form-control form-control-sm font-weight-bold" unmask="true" [imask]="{mask: '00.00.00'}"
                id="codigo">
            </div>
            <div class="form-group col-2">
              <label for="codigo" class="col-form-label">Tribunal N˚<span class="text-danger">*</span></label>
              <input #codigoe autofocus [(ngModel)]="entity.tribunal" type="text" ngModel name="tribunal"
                class="form-control form-control-sm" id="tribunal">
            </div>
            <div class="form-group col-8">
              <label for="nome" class="col-form-label">Nome da unidade executora<span
                  class="text-danger">*</span></label>
              <input [(ngModel)]="entity.nome" type="text" ngModel name="nome"
                class="form-control form-control-sm font-weight-bold" id="nome">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="atuacao" class="col-form-label">Atuação<span class="text-danger">*</span></label>
              <textarea [(ngModel)]="entity.atuacao" ngModel name="atuacao" class="form-control" id="atuacao"
                rows="4"></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="legislacao" class="col-form-label">Legislação<span class="text-danger">*</span></label>
              <textarea [(ngModel)]="entity.legislacao" ngModel name="legislacao" class="form-control" id="legislacao"
                rows="5"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button [disabled]="!f.valid || !f.dirty" type="submit" (click)="salvarExecutora(f.value)"
            class="btn btn-primary" id="btnSalvar">Salvar</button>
          <button #btnCancelarExecutora type="button" class="btn btn-link" id="btnCancelar"
            (click)="cancelarExecutora()" data-dismiss="modal">Cancelar</button>
          <button #btnFecharExecutora type="button" class="btn btn-link" id="btnFechar" data-dismiss="modal"
            style="display: none">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</div>
